<template>
  <div id="app">
    <voter :init="init"> </voter>
  </div>
</template>

<script>
import Voter from "./components/Voter";
// Componente main dell'applicazione. Richiama ed utilizza solo il componente Voter
export default {
  data: function() {
    return {
      init: false // Serve per intercettare la fine della fase di inizializzazione e mostrare
      // o meno la progress bar
    };
  },
  components: {
    Voter
  },
  created: async function() {
    await this.$store.dispatch("init", this.$keycloak);
    this.init = true;
  }
};
</script>
<style>
:root {
  --br: 20px;
  --brb: 32px;
  --pcolor: #387a8f;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  z-index: 0;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.md-dialog-container.md-theme-default {
  border-radius: var(--br);
}

.full-screen-dialog .md-dialog-container.md-theme-default {
  border-radius: 0px !important;
  overflow-x: hidden;
}

span.md-dialog-title {
  background-color: #fff !important;
  color: var(--pcolor) !important;
}

.md-button {
  transform: scaleX(1);
  will-change: transform;
}

.md-button:focus-visible,
.md-button.md-theme-default.md-raised:not([disabled]).md-accent:focus-visible,
.md-button.md-tab-nav-button:focus-visible,
.md-button.page-link:focus-visible,
a:focus-visible,
a.skip-main:focus-visible,
#close-election-button:focus-visible,
.evt-card:focus-visible {
  /*outline: none;*/
  border: 3px solid #000 !important; /*#338fff*/
  border-radius: var(--br);
}

::-moz-selection {
  background: #338fff !important;
}
::selection {
  background: #338fff !important;
}

/* Introdotto per problemi di visualizzazione: fa si che il componente venga visualizzato correttamente  */
.md-dialog-container {
  transform: scaleX(1);
}

/* Introdotto per la corretta visualizzazione dell'overlay delle popup innestate */
.md-dialog.full-screen-dialog {
  z-index: 1;
}

.full-screen-dialog .md-dialog-container {
  max-width: 100% !important;
  height: 100% !important;
  max-height: 100% !important;
  width: 100%;
  overflow: auto;
}

.final-vote .md-dialog-container {
  width: 40% !important;
}

.md-dialog-content {
  padding: 24px 0 !important;
}
.toolbar,
.tooltip {
  z-index: 2;
}

.md-dialog-actions .md-button {
  padding: 0px 24px;
}

.toolbar .md-button {
  padding: 0px 24px !important;
}

.md-button:not([disabled]).md-focused::before,
.md-button:not([disabled]):active::before,
.md-button:not([disabled]):focus::before,
.md-button:not([disabled]):focus::before,
.md-button:not([disabled]).md-focused.md-accent::before,
.md-button:not([disabled]).md-focused.md-primary::before {
  opacity: 0 !important;
}

.schededisp .md-switch.md-theme-default .md-switch-thumb {
  background: #ccc !important;
}

.check-w .md-switch.md-theme-default .md-switch-thumb {
  background: #fff;
  border-width: 1px;
  border-style: solid;
  border-color: #585252;
}

.schededisp .md-switch.md-theme-default .md-switch-container {
  background: rgba(0, 0, 0, 0.38) !important;
}

.schededisp .md-switch.md-theme-default.md-checked .md-switch-thumb {
  background: #fff !important;
}

.schededisp .md-switch.md-theme-default.md-checked .md-switch-container {
  background: #9a9a9a !important;
}

.check-w .md-switch.md-theme-default .md-switch-container {
  background: rgba(0, 0, 0, 0.38) !important;
}

.check-w .md-switch.md-theme-default.md-checked .md-switch-thumb {
  background: var(--pcolor) !important;
  border-width: 0;
}

.check-w .md-switch.md-theme-default.md-checked .md-switch-container {
  background: #8ab4c1 !important;
}

@media screen and (min-device-width: 320px) and (max-device-width: 1152px) {
  .tooltip {
    display: none !important;
  }
}

@media screen and (min-device-width: 320px) and (max-device-width: 1152px) {
  .chiudiconftooltip {
    display: none !important;
  }
}

@media screen and (max-width: 667px) {
  .final-vote .md-dialog-container {
    width: 100% !important;
  }
  .md-dialog {
    transition-duration: 0s !important;
  }
}

#menu-button {
  z-index: 0;
}

#esterno.no-navigation .md-tabs-navigation {
  display: none;
}

.close-button .md-icon.md-theme-default.md-icon-font {
  color: #fff !important;
}

.screenreader {
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

.bold {
  font-weight: 700;
}

.md-tabs.md-theme-default .md-tabs-navigation .md-button {
  font-weight: bold;
}

.md-tabs.md-theme-default .md-tabs-navigation .md-button[disabled] {
  color: var(
    --md-theme-default-text-primary-on-background,
    rgba(0, 0, 0, 0.51)
  ) !important;
}
/*Tab su più righe */
.md-tabs-navigation {
  flex-flow: row wrap !important;
}
.md-tabs-indicator {
  display: none;
}

.md-tabs.md-theme-default .md-tabs-navigation .md-button.md-active {
  border-bottom: 2px solid;
  transition-duration: 0ms;
  color: var(--pcolor) !important;
}

.md-tabs.md-theme-default .md-tabs-navigation .md-button {
  border-radius: 5px;
}

/* .md-button:not([disabled]).md-focused:before,
.md-button:not([disabled]):active:before,
.md-button:not([disabled]):hover:before {
  opacity: 0 !important;
} */

.md-button,
.md-button-clean {
  overflow: auto !important;
}

.md-table-head-container,
.md-table-head-label {
  overflow: visible !important;
}

@media screen and (max-width: 767px) {
  @-moz-document url-prefix() {
    html,
    body {
      height: 100%;
    }

    #app {
      height: 100%;
      overflow-y: scroll;
    }
  }
}

@media screen and (max-width: 370px) {
  .md-button-content {
    font-size: 13px;
  }
}
</style>
